import { useMemo } from "react";
import { useAppSelector } from "../../../../store";
import { useGetCustomerOrdersQuery } from "../../../../services/GroupManagementOverview/groupManagementOverviewAPI";
import type { CustomerOrderHistoryItem } from "../../../../services/GroupManagementOverview/groupManagementOverviewAPI.types";
import type { CustomerOrderItem } from "./CustomerOrdersWrapper/CustomerOrdersWrapper.types";

const mapOrderToItem = (order: CustomerOrderHistoryItem, aff: string): CustomerOrderItem => ({
  customerName: order.DisplayName,
  orderDate: order.Date,
  customerPv: order.PV,
  aboNo: order.AboNo,
  affAbo: `${aff}-${order.AboNo}`,
});

export const useCustomerOrdersData = (skip = false) => {
  const { user } = useAppSelector((state) => state.boot);
  const locale = useAppSelector((state) => state.loginLocalStorage.loginFields.locale || "en-US");

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetCustomerOrdersQuery(
    {
      aff: user.aff,
      abo: user.abo,
      locale,
    },
    { skip },
  );

  const isLoading = isFetching && !payloadData;

  const orders = useMemo(
    () => (payloadData?.Orders ?? []).map((order) => mapOrderToItem(order, user.aff)),
    [payloadData, user.aff],
  );

  return { orders, isLoading, isError, refetch };
};
